import { messages as messagesEN } from './en';

export const messages: typeof messagesEN = {
  HOME: { TITLE: 'strona główna', ROUTE: '/home' },
  ABOUT: { TITLE: 'O aplikacji', ROUTE: '/about' },
  DEFINE_BOX: { TITLE: 'Tabela morfologiczna', ROUTE: '/define' },
  SETTINGS: { TITLE: 'Ustawienia', ROUTE: '/settings' },
  CREATE_SCENARIO: { TITLE: 'Utwórz scenariusz', ROUTE: '/create' },
  SHOW_SCENARIO: { TITLE: 'Pokaż scenariusze', ROUTE: '/show' },
  DECISION_SUPPORT: { TITLE: 'Wsparcie decyzji', ROUTE: '/decide' },
  DOWNLOAD: {
    COLLECTION: 'Zapisz kolekcję',
    MODEL: 'Zapisz plik tabeli',
  },
  DOWNLOAD_FILENAME_TITLE: 'Zapisz plik tabeli',
  DOWNLOAD_FILENAME_LABEL: 'Nazwa pliku',
  UPLOAD: {
    COLLECTION: 'Wczytaj kolekcję',
    MODEL: 'Wczytaj plik tabeli',
  },
  OPEN_MENU: 'Otwórz menu',
  UPLOAD_FILE: 'Wczytaj tabelę lub kolekcję',
  IMPORT_READ_ERROR: 'Nie można odczytać wybranego pliku.',
  COLLECTION_LOAD_FAILED: 'Nie udało się wczytać kolekcji. Sprawdź połączenie i odśwież stronę.',
  STARTER_KIT_LOAD_FAILED: 'Nie udało się wczytać zestawu startowego. Sprawdź połączenie i spróbuj ponownie.',
  IMPORT_COLLECTION_TITLE: 'Zastąpić kolekcję?',
  IMPORT_COLLECTION_MSG:
    'Ten plik zawiera kolekcję. Wczytanie go zastąpi bieżącą kolekcję, w tym niezapisane zmiany. Kontynuować?',
  CANCEL: 'Anuluj',
  DELETE: 'Usuń',
  AND: 'i',
  YES: 'Tak',
  NO: 'Nie',
  OK: 'Ok',
  NAME: 'Nazwa',
  DESCRIPTION: 'Opis',
  NEW_BOX: 'Nowa tabela morfologiczna',
  CATEGORIES: 'Kategorie',
  DIMENSION: 'Kluczowy czynnik',
  DIMENSION_SELECTED: 'Wybrane czynniki',
  DIMENSIONS: 'Czynniki',
  KEY_VALUE: 'Wartość kluczowa',
  OPTION_USAGE_LEGEND: 'Użycie opcji w uwzględnionych scenariuszach',
  OPTION_USAGE_RANGE: 'Użyta {range} razy w uwzględnionych scenariuszach',
  OPTION_USAGE_COUNT: 'użyta {count} razy',
  CONTEXT: 'Kontekst',
  NONE: 'Brak',
  LOCATION: 'Lokalizacja',
  LOCATION_TYPE: 'Typ lokalizacji',
  COORDINATES: 'Współrzędne',
  LOCATION_NAME: 'Nazwa lokalizacji',
  LATITUDE: 'Szerokość geograficzna',
  LONGITUDE: 'Długość geograficzna',
  MANUAL: 'Tryb ręczny',
  Type: 'Typ',
  PICK_FROM_LIST: 'Wybierz z listy',
  ENTER_KEY_VALUE: 'Wprowadź wartość kluczową',
  EDIT_COMPONENT: 'Edytuj komponent',
  ADD_COMPONENT: 'Dodaj komponent',
  GENERATE_NARRATIVE: 'Generuj',
  CLEAR_NARRATIVE: 'Wyczyść',
  NAME_NARRATIVE: 'Tytuł bieżącego scenariusza',
  SAVE_NARRATIVE: 'Zapisz',
  SAVED_NARRATIVES: 'Zapisane scenariusze',
  HOME_WORK_TITLE: "Wybierz typ scenariusza",
  HOME_WORK_HINT: "Zacznij od gotowego typu scenariusza z zestawu startowego i użyj go do tworzenia i porównywania scenariuszy.",
  HOME_OPTIONS_TITLE: "Dostosuj lub utwórz własny",
  HOME_EDIT_CARD_TITLE: "Dostosuj typ scenariusza",
  HOME_EDIT_CARD_DESC: "Dodaj, zmień lub usuń czynniki i opcje, aby wybrany typ pasował do Twojej sytuacji.",
  HOME_AI_CARD_TITLE: "Utwórz nowy typ scenariusza",
  HOME_AI_CARD_DESC: "Pozwól AI zaproponować tabelę morfologiczną dla Twojego tematu albo zacznij sam od pustej tabeli.",
  HOME_MAP_CARD_TITLE: "Scenariusze na mapie",
  HOME_MAP_CARD_DESC: "Czy Twój scenariusz rozgrywa się w rozpoznawalnych miejscach, takich jak elektrownia jądrowa lub zabytek? Włącz mapę, otwórz Edytuj tabelę i za pomocą ołówka przy opcji dodaj współrzędne lub typ lokalizacji. Te miejsca pojawią się na mapie Twoich scenariuszy.",
  HOME_MAP_CARD_ENABLE: "Włącz mapę",
  HOME_MAP_CARD_ENABLED: "Mapa jest włączona. Dodaj lokalizacje do opcji w Edytuj tabelę.",
  TUTORIAL_CARD_TITLE: "Samouczek",
  TUTORIAL_CARD_DESC: "Zobacz, jak za jednym razem wygenerować kompletny scenariusz z asystentem AI: narrację, refleksje nad sposobami działania i opinie person.",
  TUTORIAL_WATCH: "Obejrzyj samouczek",
  TUTORIAL_TITLE: "Samouczek: kompletny scenariusz z AI",
  TUTORIAL_DESC: "Od zestawu startowego do decyzji: wygeneruj scenariusz, pozwól asystentowi AI napisać narrację, refleksje i opinie person jako JSON, wklej go i przeanalizuj wyniki.",
  TUTORIAL_NARRATION: "Język lektora",
  HOME_MAP_CARD_ACTIVE: "Mapa jest włączona dla tego typu scenariusza.",
  HOME_MAP_CARD_LOCATIONS: "Dodaj lokalizacje",
  DECISION_BANNER_MSG: "Ten typ scenariusza zawiera środki do wsparcia decyzji. Włącz je, aby wybierać środki, porównywać warianty działania i zapisywać decyzje.",
  DECISION_HELP_TITLE: "Jak działa wsparcie decyzji?",
  DECISION_HELP_STEP1: "W Utwórz scenariusz opisz sytuację: wybierz czynniki incydentu i zapisz scenariusz.",
  DECISION_HELP_STEP2: "W sekcji Decyzje wybierz środki pasujące do sytuacji. Każdy zestaw środków to wariant działania; utwórz kilka, aby porównać alternatywy.",
  DECISION_HELP_STEP3: "Oszacuj dla każdego wariantu działania pozostałe prawdopodobieństwo i skutki.",
  DECISION_HELP_STEP4: "Porównaj tutaj warianty działania w przeglądzie, porównaniu, widoku odporności i macierzy ryzyka.",
  DECISION_HELP_STEP5: "Zapisz decyzję wraz z uzasadnieniem w dzienniku decyzji i wyeksportuj całość do Worda.",
  PERSONA_CLIPBOARD_HINT: "Nie połączono modelu językowego, więc przycisk kopiuje prompt: wklej go do czatu swojego asystenta AI, a odpowiedź wklej w pole opinii persony. Połącz model językowy w Ustawienia → LLM, aby generować opinie bezpośrednio.",
  SETUP_LLM: "Skonfiguruj model językowy",
  NARRATIVE_PROMPT_COPIED: "Skopiowano prompt opowieści. Wklej go do czatu swojego asystenta AI, a odpowiedź wklej w pole opowieści.",
  EDIT_BOX: 'Edytuj tabelę',
  NO_SAVED_NARRATIVES: 'Nie ma jeszcze zapisanych scenariuszy w tym polu. Utwórz pierwszy.',
  NO_MATCHING_NARRATIVES: 'Żaden scenariusz nie pasuje do wyszukiwania.',
  OPEN_SCENARIO: 'Otwórz scenariusz',
  COMPARE_SCENARIOS: 'Porównaj scenariusze',
  HIDE_COMPARISON: 'Ukryj porównanie',
  BOX_ACTIONS: 'Więcej działań',
  PERMALINK: 'Kopiuj stały link',
  PERMALINK_COPIED: 'Stały link skopiowano do schowka. Wklej go do e-maila, aby udostępnić tę tabelę.',
  PERMALINK_COPIED_LONG: 'Link skopiowano, ale jest bardzo długi: niektóre programy pocztowe mogą go uciąć. Rozważ wysłanie pobranego pliku.',
  PERMALINK_INVALID: 'Udostępniony link jest nieprawidłowy lub niekompletny.',
  COLLECTION_ACTIONS: 'Zarządzanie kolekcją',
  LANGUAGE_NAMES: {
    nl: 'Nederlands', en: 'English', fr: 'Français',
    de: 'Deutsch', es: 'Español', pl: 'Polski',
  },
  FILTER_NARRATIVES: 'Filtruj scenariusze',
  FILTER_NARRATIVES_PLACEHOLDER: 'Wpisz, aby filtrować po nazwie...',
  NARRATIVE: 'scenariusz',
  INCLUDE_NARRATIVE: "Wybierz do analizy",
  NARRATIVE_INCLUDED: "Wybrany do analizy",
  SELECT_NARRATIVE: 'Wybierz scenariusz',
  SELECT_SCENARIO: "Typ scenariusza",
  SELECT_GROUP_OWN: "Moje typy scenariuszy",
  SELECT_GROUP_STARTER: "Zestaw startowy",
  KEY: 'Klucz',
  VALUE: 'Wartość',
  MODEL: 'Model',
  SELECTION: 'Wybrana wartość',
  EDITOR_PLACEHOLDER: 'Edytuj scenariusz',
  THRESHOLDS: 'Kolory progów odzwierciedlające opcje komponentów',
  THRESHOLD: 'Wartość progowa',
  COLOR: 'Kolor',
  ORDER: 'Kolejność',
  COMBINATIONS: {
    POSSIBLE: 'Kombinacje są możliwe',
    IMPOSSIBLE: 'Kombinacje są niemożliwe',
    IMPROBABLE: 'Kombinacje są mało prawdopodobne',
  },
  DELETE_ITEM: {
    title: 'Usuń {item}',
    description:
      'Czy na pewno chcesz usunąć ten element: {item}? Nie ma odwrotu.',
  },
  NEW_SCENARIO: 'Nowa tabela',
  ADD_STARTER_KIT: 'Dodaj lub zaktualizuj zestaw startowy',
  ADD_STARTER_KIT_HINT: 'Dodaje brakujące modele i persony oraz aktualizuje niezmienione. Edytowane elementy są zastępowane dopiero po Twoim potwierdzeniu.',
  STARTER_KIT_ADDED: 'Zestaw startowy: dodano {added}, zaktualizowano {updated}.',
  STARTER_KIT_CONFLICT_TITLE: 'Zastąpić edytowane elementy?',
  STARTER_KIT_CONFLICT_MSG: 'Te elementy zestawu startowego zostały przez Ciebie zmienione. Wybierz, które zastąpić aktualną wersją zestawu. Twoje zmiany, w tym narracje i decyzje, zostaną utracone. Niewybrane elementy pozostaną bez zmian.',
  STARTER_KIT_SELECT_ALL: 'Zaznacz wszystko',
  STARTER_KIT_UPDATE: 'Aktualizuj',
  STARTER_KIT_KIND_BOX: 'model',
  STARTER_KIT_KIND_PERSONA: 'persona',
  STARTER_KIT_ALREADY_PRESENT: 'Zestaw startowy jest już aktualny.',
  NEW_MODEL: {
    btn: 'Nowa kolekcja',
    title: 'Wybierz nową kolekcję',
    description:
      'Obecna kolekcja zostanie zastąpiona. Pobierz ją wcześniej, jeśli chcesz ją zachować.',
    choose: 'Wybierz nową kolekcję',
  },
  DELETE_MODEL: {
    btn: 'Usuń tabelę',
    title: 'Usuń wybraną tabelę',
    description: 'Usunąć tę tabelę i zapisane w niej scenariusze? Tej operacji nie można cofnąć.',
  },
  INCONSISTENCIES: {
    title: 'Niespójności',
    SELECT_ROW_CATEGORY: 'Wybierz kategorię wiersza',
    SELECT_COLUMN_CATEGORY: 'Wybierz kategorię kolumny',
    SELECT_CATEGORIES_TO_START: 'Wybierz kategorie, aby rozpocząć',
    NO_DRIVERS:
      'Dla tej kombinacji kategorii nie ma dostępnych kluczowych czynników z wartościami',
    NAV_TITLE: 'Nawigacja klawiaturą',
    NAV_ARROWS:
      'Strzałki: poruszanie się między komórkami, z Shift między kluczowymi czynnikami',
    NAV_TOGGLE: 'Spacja lub Enter: zmień stan kombinacji',
    NAV_SHIFT_VERTICAL:
      'Shift + Góra/Dół: zmień aktywny kluczowy czynnik wiersza',
    NAV_SHIFT_HORIZONTAL:
      'Shift + Lewo/Prawo: zmień aktywny kluczowy czynnik kolumny',
  },
  saveButton: {
    label: 'Zapisz',
    tooltip: 'Zapisz niezapisane zmiany',
  },
  i18n: {
    /** Label for the edit button of the RepeatList */
    editRepeat: 'Edytuj',
    /** Label for the create button of the RepeatList */
    createRepeat: 'Dodaj',
    /** Label for the delete button of the RepeatList */
    deleteItem: 'Usuń',
    /** Label for the agree button of the RepeatList */
    agree: 'Tak',
    /** Label for the disagree button of the RepeatList */
    disagree: 'Nie',
    /** Pick */
    pick: 'Wybierz',
    /** Pick one */
    pickOne: 'Wybierz jeden',
    /** Pick one or more */
    pickOneOrMore: 'Wybierz jeden lub więcej',
    /** Cancel button text */
    cancel: 'Anuluj',
    /** Save button text */
    save: 'Zapisz',
  },
  COMP: {
    AVAILABLEBUDGET: 'Budżet',
    BEHAVIOURDURINGPREPARATION: 'Zachowanie podczas przygotowań',
    CAPABILITIES: 'Możliwości',
    COMPARTMENTSPRESENT: 'Obecne przedziały',
    CRIMINALPHASE: 'Faza przestępcza',
    DURATION: 'Czas trwania',
    EQUIPMENT: 'Wyposażenie',
    EXISTINGINFRA: 'Istniejąca infrastruktura',
    IMPACT: 'Wpływ',
    INTENT: 'Intencja obserwatora',
    LOCATION: 'Lokalizacja',
    LOCATION2: 'Lokalizacja',
    MODUSOPERANDIDURINGEXECUTION: 'Tryb działania',
    MOTIVATION: 'Motywacja',
    NARRATIVE: 'Narracja',
    NARRATIVE_PLACEHOLDER:
      'Opisz kontekst, w którym miał miejsce incydent, np. opis lokalizacji (geograficznej), osoby lub budynku, który należy chronić, sposób, w jaki aktor uzyskuje informacje, o której godzinie miała miejsce akcja, w jakich warunkach pogodowych, ile osób było zaangażowanych w działanie, z jakiej organizacji, jak uzyskały dostęp lub jakie środki/broń zostały użyte.',
    OBJECT: 'Obiekt',
    OPENCOMPARTMENTS: 'Otwarty przedział',
    PEOPLEDENSITY: 'Gęstość zaludnienia',
    PERSONS: 'Osoba',
    PHYSICALANGLEOFATTACKDURINGEXECUTION: 'Fizyczny kąt ataku',
    PHYSICAL_ANGLE: 'Kąt fizyczny',
    PRIVACYAWARENESS: 'Świadomość prywatności',
    RELATIONOWNEROBJECTANDOWNERSECURITYSYSTEM:
      'Relacja właściciela obiektu i właściciela systemu bezpieczeństwa',
    RESPONSIBILITY: 'Odpowiedzialność',
    SCENARIOS: 'Scenariusz',
    SECURITYAWARENESS: 'Świadomość bezpieczeństwa',
    TARGETTYPE: 'Typ celu',
    THREATDIRECTION: 'Kierunek zagrożenia',
    ACTOR: 'Aktor',
    ACTION: 'Działanie',
    ACCESS: 'Dostęp',
    MEANS: 'Środki',
    TYPEOFENVIRONMENT: 'Typ środowiska',
    TYPEOFOBJECT: 'Typ obiektu',
    WEAPON: 'Broń',
    WEATHERBEHAVIOUR: 'Zachowanie pogodowe',
    WEATHERTYPE: 'Warunki pogodowe',
    PI: 'Chroniony interes (cel)',
    MEANSWEAPON: 'Środki/broń',
    MISSIONCONTEXT: 'Kontekst misji',
    ADVERSARY: 'Przeciwnik',
    C2HEADQUARTERS: 'Lokalizacja dowództwa C2',
    TARGET: 'Cel',
    DELIBERATEACTION: 'Celowe działanie',
    MEANS2: 'Środki ataku',
    MEANS3: 'Środki działania',
    MEANS4: 'Środki dostępu',
    ACCESS2: 'Sposób dostępu',
    MEANS2ACCESS: 'Środki uzyskania dostępu',
  },
  MODEL_NAMES: {
    0: 'Pusty model',
    1: 'Zestaw startowy',
  },
  MODEL_DESC: {
    0: 'Rozpocznij od pustej tabeli morfologicznej.',
    1: 'Dziesięć polskojęzycznych modeli ćwiczeń z przykładami, ograniczeniami, szablonami tekstu i poleceniami LLM.',
  },
  JSON_NOT_VALID: 'Plik modelu JSON jest nieprawidłowy! Przerywanie.',
  NO_NARRATIVE: 'Nie udało się wygenerować scenariusza w 100 próbach!',
  ALL_LOCKED_WARNING:
    'Wszystkie komponenty są zablokowane — nie można wygenerować nowego scenariusza. Najpierw wyczyść bieżący scenariusz.',
  SPEC_CATS:
    'Najpierw określ kategorie, gdzie każda kategoria zawiera kluczowe czynniki.',
  TRANSPOSE_BOX: {
    COLUMNS: 'Pokaż kluczowe czynniki jako kolumny',
    ROWS: 'Pokaż kluczowe czynniki jako wiersze',
  },
  EXPORT2WORD: {
    TITLE: 'Eksportuj do Worda',
    DESC: 'Który scenariusz chcesz wyeksportować?',
    CURRENT: 'Bieżący',
    SELECTED: 'Wybrane',
    ALL: 'Wszystkie',
    INCLUDE_BOX: 'Dołącz skrzynkę morfologiczną (jedna tabela na kategorię, wybrane wartości wyróżnione)',
    INCLUDE_DECISIONS: 'Dołącz analizę decyzyjną (przegląd, porównanie wariantów działania, macierz ryzyka i dziennik decyzji)',
  },
  HIDE_INCONSISTENT: 'Ukryj niespójne kombinacje',
  GOAL: {
    TITLE: 'Cel',
    DESC: 'ScenarioSpark to aplikacja webowa służąca do systematycznego tworzenia i zarządzania zestawem scenariuszy dla działań związanych z zarządzaniem ryzykiem.',
  },
  USAGE: {
    TITLE: 'Zastosowanie',
    DESC: 'ScenarioSpark wspiera użytkownika w tworzeniu i kompilowaniu reprezentatywnego zestawu scenariuszy, które mogą być wykorzystane w różnych etapach procesu zarządzania ryzykiem.',
  },
  SECURITY: {
    TITLE: 'Bezpieczeństwo',
    DESC: 'Wszystkie używane i wprowadzane informacje są przetwarzane i przechowywane wyłącznie lokalnie.',
  },
  SUMMARY:
    'Bezpłatne narzędzie wspierające tworzenie nowych scenariuszy przy użyciu tabeli morfologicznej. Najpierw definiujesz aspekty istotne w Twojej dziedzinie. Następnie określasz warianty dla każdego aspektu. Na koniec ręcznie tworzysz nowe scenariusze lub czerpiesz inspirację z automatycznie generowanych możliwych scenariuszy.',
  SET_LANGUAGE: 'Ustaw język',
  SCENARIO_LOADED_MSG: 'Tabela została wczytana',
  COLLECTION_LOADED_MSG: 'Kolekcja tabel została wczytana',
  SCENARIO_NOT_LOADED_MSG:
    'Tabela nie została wczytana: być może jest już w kolekcji.',
  IMPORT_CONFLICT_TITLE: 'Tabela już istnieje',
  IMPORT_CONFLICT_MSG:
    'Tabela o nazwie "{name}" jest już w Twojej kolekcji. Co chcesz zrobić?',
  IMPORT_OVERWRITE: 'Nadpisz',
  IMPORT_AS_COPY: 'Dodaj jako kopię',
  SCENARIO_CREATED_MSG: 'Tabela została utworzona',
  COPY_TO_CLIPBOARD: 'Kopiuj tabelę do schowka',
  GROUP: {
    SELECTED: 'Wybrane scenariusze',
    UNSELECTED: 'Niewybrane scenariusze',
  },
  MORE_ACTIONS: 'Więcej działań',
  CLONE_NARRATIVE: 'Klonuj',
  INCLUDE_DECISION_SUPPORT: 'Aktywuj wsparcie decyzji',
  IS_DECISION_CATEGORY: 'Do wsparcia decyzji',
  DECISION_CATEGORY_HINT: "Czynniki w kategorii decyzji są ręczne: nie są generowane, wybierasz je po opisaniu sytuacji. Kategorie decyzji są widoczne tylko wtedy, gdy wsparcie decyzji jest aktywne.",
  DECISION_CATEGORIES_HIDDEN: "Kategorie decyzji ({count}) są ukryte.",
  DECISION_CATEGORIES_OPEN_SETTINGS: "Otwórz Ustawienia",
  DECISIONS: "Decyzje",
  DECISIONS_HINT: "Wybierz działania pasujące do powyższej sytuacji. Opcje sprzeczne z sytuacją są wyszarzone.",
  EXCLUDED_BY: "wykluczone przez {situation}",
  COURSES_OF_ACTION: "Warianty działania",
  COURSE_OF_ACTION: "Wariant działania",
  COA_ACTIVE: "aktywny",
  ADD_COA: "Dodaj",
  DUPLICATE_COA: "Duplikuj",
  RENAME_COA: "Zmień nazwę wariantu działania",
  DELETE_COA: "Usuń wariant działania",
  COA_NAME: "Nazwa wariantu działania",
  COA_NOTES: "Notatki do tego wariantu działania",
  COA_HAS_CONFLICTS: "Zawiera działania sprzeczne z sytuacją",
  COA_CONFLICT: "{value} jest sprzeczne z sytuacją ({situation})",
  REFLECT_ON_DECISIONS: "Zapytaj LLM: refleksja nad decyzjami",
  COA_REFLECTION: "Refleksja nad tym wariantem działania",
  DECISION_PROMPT_COPIED: "Skopiowano prompt decyzji. Wklej go do czatu swojego asystenta AI, a odpowiedź wklej w pole refleksji.",
  DECISION_REFLECTION_ERROR: "Nie udało się wygenerować ani skopiować refleksji. Spróbuj ponownie.",
  DECISION_REFLECTION_DISCARDED: "Refleksja nie została zapisana: scenariusz lub wariant działania zmienił się podczas generowania.",
  NO_DECISION_CATEGORIES: "To pudełko nie ma kategorii decyzji. Oznacz kategorię jako „Do wsparcia decyzji” w Ustawieniach, aby porównać tutaj działania.",
  DECISION_VIEW_OVERVIEW: "Przegląd",
  DECISION_VIEW_COA: "Porównaj warianty działania",
  DECISION_VIEW_ROBUSTNESS: "Odporność",
  COMPARE_SCENARIO: "Scenariusz do porównania",
  SHOW_DIFFERENCES_ONLY: "Pokaż tylko różnice",
  NO_INCLUDED_NARRATIVES: "Nie wybrano jeszcze scenariuszy do analizy. Wybierz scenariusze na stronie Utwórz scenariusz, aby je tutaj porównać.",
  NO_CURRENT_NARRATIVE: "Nie otwarto żadnego scenariusza. Najpierw otwórz lub zapisz scenariusz na stronie Utwórz scenariusz.",
  NO_COAS: "Ten scenariusz nie ma jeszcze wariantów działania. Dodaj je na stronie Utwórz scenariusz.",
  NO_COA_DIFFERENCES: "Wszystkie warianty działania wybierają te same działania.",
  NO_DECISION_SELECTED: "brak",
  ROBUSTNESS_HINT: "Które działania sprawdzają się w bieżącym scenariuszu i w scenariuszach wybranych do analizy? Każda kolumna to scenariusz z jego aktywnym wariantem działania; działanie wybrane we wszystkich scenariuszach to bezpieczny pierwszy krok, a wybrane tylko w jednym zależy od rozwoju sytuacji.",
  ROBUSTNESS_ONE_SCENARIO: "Odporność porównuje co najmniej dwa scenariusze. Zapisz kolejny scenariusz na stronie {page} i wybierz go do analizy, aby zobaczyć, które działania sprawdzają się we wszystkich.",
  SCENARIO_CURRENT: "bieżący",
  ROBUSTNESS_MEASURE: "Działanie",
  ROBUSTNESS_CHOSEN: "Wybrane",
  ROBUSTNESS_EXCLUDED: "Wykluczone przez sytuację",
  ROBUSTNESS_UNUSED: "Nieużywane",
  ROBUSTNESS_CHOSEN_IN: "Wybrane w",
  ROBUSTNESS_COUNT: "{count} z {total}",
  ROBUSTNESS_ROBUST: "Odporne: wybrane w każdym scenariuszu",
  ROBUSTNESS_SPECIFIC: "Specyficzne dla scenariusza: wybrane tylko w jednym scenariuszu",
  SUGGESTED_WHY: "Dlaczego ta sugestia",
  SUGGESTED_HINT: "Dla każdego czynnika środki o najwyższej liczbie ważonej ryzykiem w aktywnych wariantach działania. Środki niemożliwe w każdej porównywanej sytuacji lub razem z silniejszym wyborem są pomijane; mało prawdopodobne kombinacje są dozwolone, więc sprawdź je samodzielnie.",
  SUGGESTED_PICK: "wybrano w {count} z {total} scenariuszy, waga {weight}",
  SUGGESTED_SKIPPED_EXCLUDED: "{value} pominięto: niemożliwe w każdej porównywanej sytuacji ({causes})",
  SUGGESTED_SKIPPED_CONFLICT: "{value} pominięto: niemożliwe razem z {causes}",
  SUGGESTED_NONE: "Brak sugestii: żaden scenariusz nie wybrał środka",
  SUGGESTED_NONE_EXCLUDED: "Brak sugestii: każdy wybrany środek jest niemożliwy we wszystkich porównywanych sytuacjach",
  SUGGESTED_NONE_CONFLICT: "Brak sugestii: każdy wybrany środek jest niemożliwy razem z silniejszym wyborem",
  RESIDUAL_PROBABILITY: "Prawdopodobieństwo po tym wariancie działania",
  RESIDUAL_IMPACT: "Skutki po tym wariancie działania",
  RESIDUAL_RISK: "Ryzyko szczątkowe",
  COA_RISK_HINT: "Opcjonalnie: oszacuj ryzyko, które pozostaje po realizacji tego wariantu działania. Jest ono porównywane z ryzykiem sytuacji.",
  SITUATION_RISK_HINT: "Ryzyko sytuacji bez interwencji: prawdopodobieństwo, że eskaluje lub spowoduje (dalsze) szkody, oraz skutki, jeśli tak się stanie.",
  RISK_DOWN_FROM: "Spadek z {before}",
  RISK_UP_FROM: "Wzrost z {before}",
  RISK_SAME_AS: "Tak samo jak sytuacja ({before})",
  COA_RISK_SUMMARY: "Ryzyko szczątkowe: {after} (sytuacja: {before})",
  COA_RISK_SUMMARY_SHORT: "Ryzyko szczątkowe: {after}",
  RISK_BEFORE_AFTER: "Ryzyko: sytuacja → po wariancie działania",
  RISK_TRANSITION: "{before} → {after}",
  RISK_CHANGE: { lower: "Niższe ryzyko", same: "Takie samo ryzyko", higher: "Wyższe ryzyko" },
  RISK_NOT_SET: "nie podano",
  DECISION_VIEW_RISK: "Macierz ryzyka",
  RISK_MATRIX_CAPTION: "Macierz ryzyka: prawdopodobieństwo (wiersze) × skutki (kolumny)",
  RISK_MATRIX_HINT: "Liczby to bieżący scenariusz (1) i scenariusze wybrane do analizy (ryzyko sytuacji); litery to warianty działania wybranego scenariusza (ryzyko szczątkowe).",
  RISK_MATRIX_MARKER: "Znacznik",
  RISK_MATRIX_ITEM: "Scenariusz lub wariant działania",
  RISK_MATRIX_CELL: "Prawdopodobieństwo {probability}, skutki {impact}: ryzyko {risk}",
  RISK_MATRIX_LEGEND: "Poziom ryzyka",
  RISK_LEVEL_HINT: { 0: 'Akceptowalne; dodatkowe działania nie są potrzebne.', 1: 'Akceptowalne; monitoruj sytuację.', 2: 'Ogranicz ryzyko w rozsądnym zakresie.', 3: 'Nieakceptowalne; potrzebne działania priorytetowe.', 4: 'Nieakceptowalne; działaj natychmiast.' },
  RISK_MATRIX_UNPLACED: "Nie naniesiono (brak prawdopodobieństwa lub skutków): {items}",
  RISK_MATRIX_EMPTY: "Podaj prawdopodobieństwo i skutki uwzględnionych scenariuszy, aby je nanieść.",
  CRITERIA_SCORING: "Ocena według kryteriów (opcjonalnie)",
  CRITERIA_HINT: "Oceń każdy wariant działania według kryterium od 1 (słabo) do 5 (dobrze) i ustal wagę każdego kryterium (0 = pomiń). Wynik ważony to suma waga × ocena.",
  CRITERIA: { effect: "Skuteczność", speed: "Szybkość", capacity: "Zasoby", safety: "Bezpieczeństwo ratowników", legality: "Legalność", acceptance: "Akceptacja społeczna" },
  CRITERIA_CRITERION: "Kryterium",
  CRITERIA_WEIGHT: "Waga",
  CRITERIA_WEIGHT_FOR: "Waga kryterium {criterion}",
  CRITERIA_SCORE_FOR: "Ocena wariantu działania {coa} dla kryterium {criterion}",
  CRITERIA_TOTAL: "Wynik ważony",
  CRITERIA_RANK: "Miejsce",
  CRITERIA_TOTAL_OF: "{total} z {max}",
  CRITERIA_MISSING: "bez oceny: {count}",
  DECISION_EXPORT: "Eksportuj do Worda",
  DECISION_EXPORT_TITLE: "Wsparcie decyzji",
  DECISION_EXPORT_DATE: "Wyeksportowano {date}",
  DECISION_LOG: "Rejestr decyzji",
  DECISION_LOG_HINT: "Zapisuj podjęte decyzje wraz z uzasadnieniem. Wpisy pozostają po usunięciu scenariusza lub wariantu działania.",
  DECISION_LOG_EMPTY: "Nie zapisano jeszcze żadnych decyzji.",
  RECORD_DECISION: "Zapisz decyzję",
  EDIT_DECISION: "Edytuj decyzję",
  DELETE_DECISION: "Usuń decyzję",
  DECISION_LOG_DATE: "Data i godzina",
  DECISION_LOG_SCENARIO: "Scenariusz",
  DECISION_LOG_DECISION: "Decyzja",
  DECISION_LOG_RATIONALE: "Uzasadnienie",
  DECISION_LOG_AUTHOR: "Decyzję podjął(a)",
  DECISION_LOG_REMOVED: "usunięto",
  DECISION_LOG_NO_SCENARIO: "Brak konkretnego scenariusza",
  DECISION_LOG_NO_COA: "Brak konkretnego wariantu działania",
  DECISION_LOG_EDITED: "edytowano {date}",
  CRITERIA_NOT_SCORED: "bez oceny",
  DECISION_PROMPT_TITLE: "Włączyć wsparcie decyzji?",
  DECISION_PROMPT_MSG: "To pudełko zawiera kategorie decyzji, np. działania wybierane po opisaniu sytuacji. Włącz wsparcie decyzji, aby je wybierać i porównywać.",
  DECISION_PROMPT_LATER_NOTE: "Możesz to później zmienić w Ustawieniach.",
  DECISION_PROMPT_ENABLE: "Włącz",
  DECISION_PROMPT_NOT_NOW: "Nie teraz",
  PROBABILITY: 'Prawdopodobieństwo wystąpienia',
  IMPACT: 'Wpływ',
  RISK: 'Ryzyko',
  RISK_PLACEHOLDER: 'Prawdopodobieństwo x Wpływ',
  PROB5: {
    0: 'Bardzo niskie',
    1: 'Niskie',
    2: 'Średnie',
    3: 'Wysokie',
    4: 'Bardzo wysokie',
  },
  IMP5: {
    0: 'Bardzo niski',
    1: 'Niski',
    2: 'Średni',
    3: 'Wysoki',
    4: 'Bardzo wysoki',
  },
  RISK5: {
    0: 'Bardzo niskie',
    1: 'Niskie',
    2: 'Średnie',
    3: 'Wysokie',
    4: 'Bardzo wysokie',
  },
  SUGGESTED_APPROACH: {
    TITLE: 'Sugerowane podejście',
    DESC: 'Sugerowane podejście to kombinacja wybranych środków zaradczych ważona (ryzykiem).',
  },
  TEMPLATE: {
    TITLE: 'Szablon ciągłego tekstu',
    DESC: 'Napisz akapit, w którym XXX zostanie zastąpione wartością dla kluczowego czynnika 1, itd. Puste wiersze są konwertowane na akapity.',
  },
  SELECT_PERSONA: 'Wybierz odpowiednią personę dla scenariusza',
  SELECT_PERSONA_HELP: 'Zapisz, jak każda wybrana persona postrzega zapisany scenariusz, reaguje na środki i jak należy ją informować lub angażować.',
  PERSONA_IMPRESSION: 'Opinia persony',
  COPY_PERSONA_PROMPT: 'Kopiuj prompt opinii',
  COPY_PERSONA_PROMPT_SHORT: 'Kopiuj',
  COPY_PERSONA_PROMPT_FOR: 'Kopiuj prompt opinii dla {persona}',
  GENERATE_PERSONA_FEEDBACK: 'Generuj opinię',
  GENERATE_PERSONA_FEEDBACK_SHORT: 'Generuj',
  GENERATE_PERSONA_FEEDBACK_FOR: 'Generuj opinię dla {persona}',
  PERSONA_PROMPT_COPIED: "Skopiowano prompt opinii. Wklej go do czatu swojego asystenta AI, a odpowiedź wklej w to pole.",
  PERSONA_PASTE_HINT: 'Wklej odpowiedź LLM bezpośrednio w pole powyżej; zostanie zapisana automatycznie.',
  PERSONA_FEEDBACK_ERROR: 'Nie udało się wygenerować lub skopiować opinii. Spróbuj ponownie.',
  PERSONA: {
    1: 'Persona',
    n: 'Persony',
  },
  IMAGE: 'Obraz',
  SAVE: 'Zapisz',
  EDIT: 'Edytuj',
  MARKDOWN_FIELD_EMPTY: "Kliknij, aby dodać tekst",
  LLM: 'LLM',
  SERVICE: 'Usługa',
  PROVIDER: 'Dostawca',
  SYSTEM_PROMPT: 'Prompt systemowy',
  USER_PROMPT: 'Prompt narracji',
  EFFECT_PROMPT: 'Prompt efektu',
  PERSONA_PROMPT: 'Prompt persony',
  COMMUNICATIONS_PROMPT: 'Prompt komunikacji',
  TEMPERATURE: {
    BTN: 'Temperatura',
    DESC: 'Jak kreatywny powinien być LLM (maks. = 1)?',
  },
  API_KEY: 'Klucz API',
  URL: 'URL',
  ASK_LLM: 'Zapytaj LLM',
  INCLUDE_LLM: 'Uwzględnij w LLM',
  OLLAMA_URL:
    'Nazwa hosta (i opcjonalnie port, przez [proxy](https://github.com/erikvullings/proxy))',
  ADV_EDIT: 'Edytor kodu',
  TOGGLE: { SHOW: 'Pokaż tabelę', HIDE: 'Ukryj tabelę' },
  AUTO_CREATE: {
    BTN: 'Automatyczne tworzenie',
    COUNT: 'Liczba automatycznych utworzeń LLM',
    COUNT_DESC: 'Ile scenariuszy chcesz wygenerować jednocześnie?',
  },
  AUTO_CREATE_MSG: {
    1: `Automatycznie utwórz 1 scenariusz`,
    n: 'Automatycznie utwórz {n} scenariuszy',
  },
  COPY_BOX: {
    LABEL: 'Kopiuj tabelę',
    TITLE: 'Kopiuj tabelę do schowka',
    TOAST: 'Tabela morfologiczna skopiowana do schowka.',
  },
  PROMPT_TYPE: {
    PROMPTS: 'Prompty',
    LABEL: 'Typ promptu',
    NARRATIVE: 'Prompt narracji',
    EFFECT: 'Prompt efektu',
    PERSONA: 'Prompt persony',
    COM: 'Prompt komunikacji',
    DECISION: "Prompt refleksji nad decyzjami",
  },
  LLM_DEFAULT_NARRATIVE_PROMPT:
    'Uzyj ponizszych elementow, aby zdefiniowac realistyczny scenariusz.',
  LLM_INCLUDED_CATEGORIES: 'Uwzględnione kategorie',
  LLM_PROMPT_TEXT: 'Prompt',
  LLM_CATEGORY_REQUIRED: 'Wybierz co najmniej jedną kategorię dla tego promptu.',
  LLM_DEFAULT_PERSONA_PROMPT:
    'Opisz, jak wskazana persona postrzega tę sytuację, w tym proponowane środki oraz, jeśli to istotne, jak ją poinformować lub zaangażować. Oprzyj opinię na scenariuszu i opisach person; nie wymyślaj szczegółów. Zwróć wyłącznie opinię wskazanej persony, gotową do wklejenia w jej pole. Nie dodawaj nagłówka, nazwy persony ani bloków kodu.',
  LLM_PERSONA_CONTEXT: 'Wybrane persony i opisy:\n{personas}',
  LLM_PERSONA_TARGET: 'Napisz opinię tylko dla: {persona}',
  LLM_SCENARIO_TEXT: 'Opis scenariusza:\n{narrative}',
  LLM_SITUATION: "Sytuacja (użyj tych elementów, aby opisać incydent):",
  LLM_SUGGESTED_ACTIONS: "Proponowane działania (środki do opisania i oceny):",
  LLM_NO_MEASURES_SELECTED: "Nie wybrano żadnych środków: opisz tylko incydent i nie wymyślaj środków ani rozwiązania.",
  LLM_DEFAULT_DECISION_PROMPT: "Jesteś doświadczonym doradcą ds. zarządzania kryzysowego. Oceń poniższy wariant działania dla danej sytuacji. Trzymaj się podanej sytuacji i opisu scenariusza; nie wymyślaj faktów. Pisz zwięźle: maksymalnie 250 słów, w Markdown, z dokładnie tymi częściami: **Ocena** (2–3 zdania o adekwatności, czasie i kolejności), **Mocne strony** (2 punkty), **Ryzyka i luki** (2–3 punkty, w tym czego brakuje) oraz **Usprawnienie** (1 konkretna rekomendacja). Nie dodawaj tytułu ani bloków kodu.",
  LLM_DECISION_SITUATION: "Sytuacja (incydent, na który odpowiadają decyzje):",
  LLM_COA_DECISIONS: "Wariant działania {coa}: decyzje do oceny:",
  LLM_COA_NO_DECISIONS: "Wariant działania {coa} nie ma jeszcze wybranych decyzji: wskaż, jakie decyzje są potrzebne.",
  LLM_OTHER_COAS: "Inne rozważane warianty działania (tylko dla porównania; nie oceniaj ich):",
  LLM_COMBINED_INTRO: "Wykonaj wszystkie poniższe zadania dla jednego scenariusza. Odpowiedz jednym obiektem JSON w bloku kodu ```json i niczym więcej.",
  LLM_COMBINED_TASK_NARRATIVE: "Zadanie: napisz opis scenariusza",
  LLM_COMBINED_CURRENT_NARRATIVE: "Obecny opis scenariusza (popraw go i zachowaj to, co nadal pasuje):\n{narrative}",
  LLM_COMBINED_TASK_DECISIONS: "Zadanie: oceń każdy wariant działania",
  LLM_COMBINED_TASK_PERSONAS: "Zadanie: napisz informację zwrotną dla każdej persony na podstawie Twojego opisu",
  LLM_COMBINED_OUTPUT: "Format odpowiedzi (te zasady mają pierwszeństwo przed wcześniejszymi instrukcjami formatowania): uzupełnij poniższy szablon JSON. Nie zmieniaj żadnego id, wpisz krótki, opisowy tytuł w \"title\", pisz teksty w Markdown, używaj \\n do łamania wierszy w ciągach i nie dodawaj innych pól ani tekstu poza blokiem kodu.",
  COMBINED_PROMPT: "Prompt „wszystko w jednym”",
  COMBINED_PROMPT_TITLE: "Jeden prompt dla opisu scenariusza, oceny wariantów działania i informacji zwrotnej person; wklej odpowiedź JSON",
  COMBINED_TITLE: "Prompt AI „wszystko w jednym”",
  COMBINED_HINT: "Prompt jest w schowku. Wklej go do asystenta AI (np. Copilot) i wklej poniżej jego odpowiedź JSON. To okno pozostaje w tym czasie otwarte.",
  COMBINED_COPY: "Kopiuj prompt",
  COMBINED_COPIED: "Prompt skopiowany. Wklej poniżej odpowiedź JSON.",
  COMBINED_PASTE: "Odpowiedź AI (JSON)",
  COMBINED_PARSE_ERROR: "Nie znaleziono poprawnego JSON w tej odpowiedzi. Poproś AI o zwrócenie tylko bloku kodu JSON.",
  COMBINED_APPLY: "Zastosuj",
  COMBINED_APPLIED: "Scenariusz zaktualizowany na podstawie odpowiedzi AI.",
  COMBINED_UNMATCHED: "Nie rozpoznano, pominięto: {names}",
  COMBINED_REPLACES: "zastępuje istniejący tekst",
  COMBINED_FIELD_TITLE: "Tytuł",
  COMBINED_FIELD_NARRATIVE: "Opis scenariusza",
  COMBINED_HINT_API: "Wygeneruj odpowiedź za pomocą skonfigurowanej usługi AI albo skopiuj prompt i wklej poniżej odpowiedź JSON. Sprawdź wynik przed zastosowaniem.",
  COMBINED_GENERATE: "Generuj",
  COMBINED_GENERATE_ERROR: "Usługa AI nie zwróciła odpowiedzi. Sprawdź ustawienia LLM lub skopiuj prompt.",
  LLM_FIELD_PROMPTS: "Prompt dla każdego pola",
  LLM_FIELD_PROMPTS_DESC: "Prompt „wszystko w jednym” pozostaje dostępny. Pokaż też przycisk promptu przy opisie scenariusza, każdej ocenie i każdej personie, aby (ponownie) wygenerować tylko tę część.",
  AI_NARRATIVE: "Zapytaj LLM: napisz opis scenariusza",
  COPY_NARRATIVE_PROMPT: "Kopiuj prompt opisu scenariusza",
  NARRATIVE_PASTE_HINT: "Skopiuj prompt, zapytaj asystenta AI i wklej odpowiedź w polu opisu scenariusza.",
  NARRATIVE_GENERATE_ERROR: "Nie udało się wygenerować opisu scenariusza. Sprawdź ustawienia LLM.",
  RESPONSE_INSTRUCTIONS:
    'Rozpocznij odpowiedź krótkim, opisowym tytułem w osobnej linii, następnie pustą linią, a potem główną treścią.',
  WIZARD_STEP1_TITLE: 'Informacje o tabeli',
  WIZARD_STEP1_SUBTITLE: 'Nazwij i opisz swoją tabelę',
  WIZARD_STEP2_TITLE: 'Kluczowe czynniki',
  WIZARD_STEP2_SUBTITLE:
    'Zdefiniuj kategorię morfologiczną i kluczowe czynniki',
  WIZARD_STEP3_TITLE: 'Opcje czynników',
  WIZARD_STEP3_SUBTITLE: 'Opcjonalnie dodaj opcje dla każdego czynnika',
  WIZARD_CATEGORY_INFO: 'Szczegóły kategorii',
  WIZARD_COMPONENTS_INFO: 'Kluczowe czynniki (wymiary)',
  WIZARD_VALUES_INFO: 'Wybierz czynnik, aby dodać opcje:',
  WIZARD_NO_COMPONENTS: 'Nie zdefiniowano jeszcze czynników. Wróć do kroku 2.',
  WIZARD_VALUES_FOR_COMPONENT: 'Opcje dla {component}',
  WIZARD_DEFAULT_CATEGORY_NAME: 'Początkowa Tabela Morfologiczna',
  WIZARD_NEXT: 'Dalej',
  WIZARD_PREVIOUS: 'Wstecz',
  WIZARD_COMPLETE: 'Utwórz tabelę',
  WIZARD_SKIP: 'Pomiń',
  LLM_WIZARD_TITLE: 'Utwórz tabelę z AI',
  LLM_WIZARD_STEP1_TITLE: 'Określ wymagania',
  LLM_WIZARD_STEP1_SUBTITLE: 'Określ, co chcesz wygenerować',
  LLM_WIZARD_STEP1_DESC:
    'Wypełnij poniższe szczegóły, aby dostosować generowanie tabeli morfologicznej:',
  LLM_WIZARD_STEP2_TITLE: 'Przejrzyj prompt',
  LLM_WIZARD_STEP2_SUBTITLE: 'Przejrzyj i edytuj kompletny prompt',
  LLM_WIZARD_STEP2_DESC:
    'Przejrzyj poniższy połączony prompt. Możesz go edytować, jeśli to konieczne:',
  LLM_WIZARD_STEP3_TITLE: 'Skonfiguruj LLM',
  LLM_WIZARD_STEP3_SUBTITLE: 'Wybierz usługę i ustawienia LLM',
  LLM_WIZARD_STEP3_DESC:
    'Skonfiguruj sposób generowania tabeli morfologicznej:',
  LLM_WIZARD_STEP4_TITLE: 'Wygeneruj tabelę',
  LLM_WIZARD_STEP4_SUBTITLE: 'Wygeneruj lub wklej wynik',
  LLM_WIZARD_STEP4_CLIPBOARD_DESC:
    'Prompt jest gotowy. Skopiuj go i użyj zewnętrznego LLM do wygenerowania tabeli morfologicznej:',
  LLM_PURPOSE: 'Cel',
  LLM_PURPOSE_HELP:
    'Co chcesz zbadać lub zaprojektować? Np. "scenariusze zarządzania kryzysowego dla krajowego planowania awaryjnego"',
  LLM_DOMAIN: 'Dziedzina',
  LLM_DOMAIN_HELP:
    'Określ obszar lub kontekst, np. "reagowanie na katastrofy", "cyberbezpieczeństwo", "operacje wojskowe"',
  LLM_OUTPUT_TYPE: 'Typ wyniku',
  LLM_OUTPUT_TYPE_HELP:
    'Jedna tabela morfologiczna, wiele tabel, scenariusz, środki zaradcze, czy oba?',
  LLM_CONSTRAINTS: 'Ograniczenia lub obszary skupienia',
  LLM_CONSTRAINTS_HELP:
    'Np. "Uwzględnij czynniki społeczno-polityczne, środowiskowe i technologiczne"',
  LLM_DETAIL_DEPTH: 'Głębokość szczegółów',
  LLM_DETAIL_DEPTH_HELP:
    'Np. "Uwzględnij 6-7 szczegółowych opcji na czynnik, każda z definicją w jednym zdaniu"',
  LLM_LANGUAGE: 'Język wyniku',
  LLM_LANGUAGE_HELP: 'Język wygenerowanej treści, np. "angielski", "polski"',
  LLM_FULL_PROMPT: 'Kompletny prompt',
  LLM_ENDPOINT: 'Metoda generowania',
  LLM_CLIPBOARD: 'Kopiuj do schowka (użyj zewnętrznego LLM)',
  LLM_OLLAMA: 'Generuj za pomocą Ollama',
  LLM_OPENAI: 'Generuj za pomocą OpenAI',
  LLM_OLLAMA_URL_HELP: 'URL API Ollama, np. http://localhost:11434/api/chat',
  LLM_OPENAI_URL_HELP: 'URL API OpenAI (zostaw puste dla domyślnego)',
  LLM_OLLAMA_MODEL_HELP: 'Nazwa modelu, np. gemma2, llama3, qwen2.5',
  LLM_OPENAI_MODEL_HELP: 'Nazwa modelu, np. gpt-4o-mini, gpt-4o',
  LLM_COPY_PROMPT: 'Kopiuj prompt do schowka',
  TEMPLATE_PROMPT_COPIED: 'Prompt szablonu skopiowany do schowka',
  TEMPLATE_PROMPT_COPY: 'Kopiuj prompt LLM do schowka',
  LLM_PROMPT_COPIED: 'Prompt skopiowany do schowka!',
  LLM_PASTE_OUTPUT: 'Wklej wynik LLM poniżej:',
  LLM_GENERATE: 'Generuj za pomocą LLM',
  LLM_GENERATING: 'Generowanie za pomocą LLM...',
  LLM_ERROR: 'Błąd generowania',
  INCLUDE_MAP_SUPPORT: 'Aktywuj obsługę mapy',
  SETTINGS_GENERAL: "Ogólne",
  SETTINGS_OPTIONS: "Opcje",
  SETTINGS_NARRATIVE: "Narracja",
  SETTINGS_MAP: "Mapa",
  SETTINGS_STRUCTURE: "Struktura skrzynki",
  HIDE_INCONSISTENT_HINT: "Podczas tworzenia scenariusza ukrywaj opcje niemożliwe przy dokonanym wyborze, zamiast tylko je oznaczać.",
  INCLUDE_MAP_SUPPORT_HINT: "Pokazuj mapę podczas definiowania skrzynki oraz tworzenia i przeglądania scenariuszy, aby umieszczać czynniki w terenie.",
  INCLUDE_DECISION_SUPPORT_HINT: "Pokazuj kategorie działań, warianty działania i stronę decyzji.",
  MAP_CONFIG: 'Konfiguracja mapy',
  MAP_UNITS: 'Jednostki mapy',
  METRIC: 'Metryczny',
  IMPERIAL: 'Imperialny',
  OSM_AMENITIES: 'Udogodnienia OSM',
  TOGGLE_MAP: 'Pokaż/ukryj mapę',
  ZOOM_LEVEL: 'Poziom powiększenia',
  CIRCLE: 'Okrąg',
  ELLIPSE: 'Elipsa',
  OSM_QUERY: 'Zapytanie OSM',
  RADIUS: 'Promień (m)',
  RADII: 'Promienie (oddzielone przecinkami, w metrach)',
  MAJOR_AXIS: 'Półoś wielka (m)',
  MINOR_AXIS: 'Półoś mała (m)',
  ORIENTATION: 'Orientacja',
  ORIENTATION_DESC: 'Kąt w stopniach (0 = Północ) lub ID referencyjny',

  LLM_GENERATED_MARKDOWN: 'Wygenerowany Markdown',

  IMPORT_FROM_SPREADSHEET: 'Wklej z arkusza',
  IMPORT_PASTE_DATA: 'Wklej dane z arkusza',
  IMPORT_PLACEHOLDER:
    'Wklej tutaj dane rozdzielane tabulatorami z Excela/Google Sheets...\n\nPierwszy wiersz = nazwy kluczowych czynników, każda kolumna = opcje dla tego czynnika.',
  IMPORT_PARSE: 'Przetwarzaj i importuj',
  IMPORT_NO_DATA: 'Nie wykryto danych tabeli. Wklej tabelę i spróbuj ponownie.',
  IMPORT_NO_DRIVERS: 'Nie wykryto kluczowych czynników. Sprawdź wklejone dane.',
  IMPORT_NEEDS_TWO_COLUMNS:
    'Import wymaga co najmniej 2 kolumn (nazwy czynników i opcje).',
  CLOSE_MESSAGE: 'Zamknij komunikat',
  SEARCH_SCENARIO_TYPE: 'Szukaj typów scenariuszy…',
  NO_SCENARIO_TYPE_FOUND: 'Nie znaleziono typów scenariuszy',
  COVERAGE_MENU: "Generuj zestaw pokrywający…",
  COVERAGE_TITLE: "Generuj scenariusze pokrywające skrzynkę",
  COVERAGE_DESC: "Tworzy różne scenariusze, w których każda opcja występuje mniej więcej równie często, zamiast wybierać je losowo. Zablokowane opcje są zachowywane, niemożliwe kombinacje nigdy nie są używane, a mało prawdopodobne są unikane. Istniejące uwzględnione scenariusze liczą się do równowagi.",
  COVERAGE_COUNT: "Liczba scenariuszy",
  COVERAGE_BATCH_NAME: "Nazwa serii (prefiks nazw scenariuszy)",
  COVERAGE_BATCH_DEFAULT: "Seria",
  COVERAGE_PAIRS: "Rozkładaj także kombinacje opcji (parami)",
  COVERAGE_START: "Generuj",
  COVERAGE_STOP: "Zatrzymaj",
  COVERAGE_PROGRESS: "{done} z {total} scenariuszy",
  COVERAGE_DONE: "Dodano {count} scenariuszy do „{batch}”",
  COVERAGE_EXHAUSTED: "Udało się utworzyć tylko {count} nowych, różnych i spójnych scenariuszy.",
  DELETE_BATCH_MENU: "Usuń wygenerowaną serię…",
  DELETE_BATCH_TITLE: "Usuń serię wygenerowanych scenariuszy",
  DELETE_BATCH_SELECT: "Seria",
  DELETE_BATCH_KEEP_TEXT: "Zachowaj scenariusze, które mają już narrację",
  DELETE_BATCH_DONE: "Usunięto {count} scenariuszy",
  SHOW_GENERATED: "Pokaż {count} wygenerowanych scenariuszy bez narracji",
};
